import { PromptVersion } from "@/types/apiGetters";

export const promptInputVariables = (promptVersion?: PromptVersion) => {
  const promptTemplateVariables = promptVersion?.prompt_template?.input_variables;
  const renderedTemplateVariables = promptVersion?.rendered_template?.input_variables;
  const variables = Array.isArray(promptTemplateVariables)
    ? promptTemplateVariables
    : renderedTemplateVariables;

  if (!Array.isArray(variables)) {
    return [];
  }

  return variables.map(String).filter(Boolean);
};
